import { Injectable, inject } from '@angular/core';

import { ClientConfigDBService } from '../db/client-config-db-service';
import { Resolve } from '@angular/router';
import { CategoryConfig } from '@core/api';

@Injectable()
export class CategoryConfigResolver implements Resolve<CategoryConfig> {
  private clientConfigDbService = inject(ClientConfigDBService);

  public resolve() {
    return this.clientConfigDbService.getCategoryConfig();
  }
}
